import React from 'react';
import './PetPreform.css';
import pet1 from '../../../imgs/phonec.webp';  
import pet2 from '../../../imgs/twocolorp.webp';  


const Twoprod = () => {
  return (
    <div className="petf">
      <div className="petf-card">
        <img
          src={pet1}
          alt="Pet Preform 1"
          className="petf-img" data-aos="fade-down"
        />
        <p className="description-box">This is the description for Pet Preform 1.</p>

      </div>
      <div className="petf-card">
        <img
          src={pet2}
          alt="Pet Preform 2"
          className="petf-img"data-aos="fade-down"
        />  
        <p className="description-box">This is the description for Pet Preform 1.</p>
    
      </div>
    </div>
  );
};

export default Twoprod;
